"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.default = {
    info: function (message) {
        var _a;
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        (_a = window.console).info.apply(_a, tslib_1.__spreadArrays([message], optionalParams));
    },
    warn: function (message) {
        var _a;
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        (_a = window.console).warn.apply(_a, tslib_1.__spreadArrays([message], optionalParams));
    },
    error: function (name) {
        var _a;
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        (_a = window.console).error.apply(_a, tslib_1.__spreadArrays([name], optionalParams));
    },
};
//# sourceMappingURL=logger.js.map